import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const commitments = ['Service that exceeds expectations', 'Regular consultation and follow-up', 'Safe and hygienic work environment', 'Timely response to all requests'];
export function CommitmentSection() {
  return <section id="commitment" className="py-24 bg-warm-grey overflow-hidden" data-id="element-38">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-40">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="order-2 lg:order-1" data-id="element-41">
            <div className="flex items-center gap-3 mb-6" data-id="element-42">
              <span className="text-primary text-xs font-bold tracking-widest uppercase" data-id="element-43">
                Our Promise
              </span>
              <div className="h-[1px] w-12 bg-border" data-id="element-44" />
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-8 leading-tight" data-id="element-45">
              Committed to Your Success
            </h2>

            <p className="text-lg text-body mb-10 leading-relaxed" data-id="element-46">
              We don't just fix problems; we partner with you to ensure your
              commercial space operates flawlessly. Our commitment is reflected
              in every project we undertake.
            </p>

            <ul className="space-y-6" data-id="element-47">
              {commitments.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1 + 0.3
            }} className="flex items-start gap-4" data-id="element-48">
                  <CheckCircleIcon className="w-6 h-6 text-primary shrink-0 mt-0.5" data-id="element-49" />
                  <span className="text-lg font-medium text-charcoal" data-id="element-50">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1],
          delay: 0.2
        }} className="order-1 lg:order-2 relative" data-id="element-51">
            <div className="relative rounded-lg overflow-hidden shadow-xl" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/xyFfRZhLSEEcjbaXUd2Xha/Gemini_Generated_Image_1ovgqg1ovgqg1ovg.png" alt="Construction team reviewing blueprints" className="w-full h-auto object-cover aspect-[4/3] md:aspect-[3/2] lg:aspect-[4/5]" data-id="element-53" />
              <div className="absolute inset-0 bg-charcoal/10 mix-blend-multiply" data-id="element-54" />
              <div className="absolute inset-0 ring-1 ring-inset ring-black/10 rounded-lg" data-id="element-55" />
            </div>

            {/* Decorative Accent */}
            <div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-primary rounded-tr-2xl -z-10" data-id="element-56" />
            <div className="absolute -bottom-4 -left-4 w-24 h-24 border-b-2 border-l-2 border-primary rounded-bl-2xl -z-10" data-id="element-57" />
          </motion.div>
        </div>
      </div>
    </section>;
}